import { createBrowserRouter } from 'react-router';
import { AppLayout } from './components/AppLayout';
import { AcceptInvitePage } from './routes/AcceptInvitePage';
import { AccountDetailPage } from './routes/AccountDetailPage';
import { AccountPage } from './routes/AccountPage';
import { AccountsPage } from './routes/AccountsPage';
import { ActivityPage } from './routes/ActivityPage';
import { AddPage } from './routes/AddPage';
import { BudgetFormPage, BudgetsPage } from './routes/BudgetsPage';
import { ReportsPage } from './routes/ReportsPage';
import { CategoriesPage } from './routes/CategoriesPage';
import { DebtDetailPage } from './routes/DebtDetailPage';
import { DebtPayPage } from './routes/DebtPayPage';
import { PlanPage } from './routes/PlanPage';
import { DebtsPage } from './routes/DebtsPage';
import { FamilyHubPage } from './routes/FamilyHubPage';
import { AddMemberPage } from './routes/AddMemberPage';
import { FamilyPage } from './routes/FamilyPage';
import { GoalDetailPage, GoalFormPage, GoalsPage } from './routes/GoalsPage';
import { HomePage } from './routes/HomePage';
import { LoginPage } from './routes/LoginPage';
import { MemberDetailPage } from './routes/MemberDetailPage';
import { MembersPage } from './routes/MembersPage';
import { NewAccountPage } from './routes/NewAccountPage';
import { NewDebtPage } from './routes/NewDebtPage';
import { NotFoundPage } from './routes/NotFoundPage';
import { PayeesPage } from './routes/PayeesPage';
import { PeoplePage } from './routes/PeoplePage';
import { PersonPage } from './routes/PersonPage';
import { RatesPage } from './routes/RatesPage';
import { RecurringFormPage, RecurringPage } from './routes/RecurringPage';
import { RegisterPage } from './routes/RegisterPage';
import { TransactionDetailPage } from './routes/TransactionDetailPage';

export const routes = [
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/invite/:token', element: <AcceptInvitePage /> },
  {
    element: <AppLayout />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/add', element: <AddPage /> },
      { path: '/activity', element: <ActivityPage /> },
      { path: '/activity/:id', element: <TransactionDetailPage /> },
      { path: '/recurring', element: <RecurringPage /> },
      { path: '/recurring/new', element: <RecurringFormPage /> },
      { path: '/recurring/:id', element: <RecurringFormPage /> },
      { path: '/reports', element: <ReportsPage /> },
      { path: '/budgets', element: <BudgetsPage /> },
      { path: '/budgets/set', element: <BudgetFormPage /> },
      { path: '/goals', element: <GoalsPage /> },
      { path: '/goals/new', element: <GoalFormPage /> },
      { path: '/goals/:id', element: <GoalDetailPage /> },
      { path: '/goals/:id/edit', element: <GoalFormPage /> },
      { path: '/debts', element: <DebtsPage /> },
      { path: '/debts/new', element: <NewDebtPage /> },
      { path: '/debts/:id', element: <DebtDetailPage /> },
      { path: '/debts/:id/pay', element: <DebtPayPage /> },
      { path: '/debts/:id/plan', element: <PlanPage /> },
      { path: '/people', element: <PeoplePage /> },
      { path: '/people/:id', element: <PersonPage /> },
      { path: '/members', element: <MembersPage /> },
      { path: '/members/new', element: <AddMemberPage /> },
      { path: '/members/:id', element: <MemberDetailPage /> },
      { path: '/accounts', element: <AccountsPage /> },
      { path: '/accounts/new', element: <NewAccountPage /> },
      { path: '/accounts/:id', element: <AccountDetailPage /> },
      { path: '/categories', element: <CategoriesPage /> },
      { path: '/family', element: <FamilyHubPage /> },
      { path: '/family/settings', element: <FamilyPage /> },
      { path: '/family/rates', element: <RatesPage /> },
      { path: '/family/payees', element: <PayeesPage /> },
      { path: '/account', element: <AccountPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
];

export function createRouter() {
  return createBrowserRouter(routes);
}
